<template>
	<div class="c-inquiry__body">
				<div class="inquiry-form__title-block">
					<p class="inquiry-form__form-title">{{msg.personal_info}}</p>
					<span class="inquiry-form__required-mark">
						{{msg.required}}
					</span>
				</div>

				<div class="row">
					<div class="col-12 col-lg-6">
						<label class="inquiry-form__label">
							<input type="text" name="first_name" value="" class="inquiry-form__input-text" :placeholder="msg.first_name">
						</label>
					</div>
					<div class="col-12 col-lg-6">
						<label class="inquiry-form__label">
							<input type="text" name="last_name" value="" class="inquiry-form__input-text" :placeholder="msg.last_name">
						</label>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-lg-6">
						<label class="inquiry-form__label">
							<input type="mail" name="email" value="" class="inquiry-form__input-text" :placeholder="msg.email">
						</label>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<label class="inquiry-form__label">
							<textarea name="message" rows="8" cols="80" :placeholder="msg.message" class="inquiry-form__input-textarea"></textarea>
						</label>
					</div>
				</div>

				<div class="inquiry-form__bottom">
					<div class="inquiry-form__opt">
						<label class="inquiry-form__label">
							<input type="checkbox" name="gdpr_accept" value="" class="inquiry-form__input-check">
							{{msg.form_gdpr}}
						</label>
						<label class="inquiry-form__label">
							<input type="checkbox" name="newsletter_accept" value="" class="inquiry-form__input-check">
							{{msg.form_newsletter}}
						</label>

					</div>
				</div>

				</div>
</template>

<script>
	export default {
		data() {
			return {
				//
			}
		},	
	}
</script>

<style>

</style>
